/**
 * Chutt... - Sentiment Bar
 * Horizontal bar showing positive/neutral/negative sentiment distribution
 */
import React from 'react';
import { Box, Typography, Tooltip, Skeleton } from '@mui/material';
import { colors } from '../../styles/colors';

function SentimentBar({ positive, neutral, negative, loading }) {
  if (loading) {
    return <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1 }} />;
  }

  const total = positive + neutral + negative || 1;
  const positivePct = (positive / total) * 100;
  const neutralPct = (neutral / total) * 100;
  const negativePct = (negative / total) * 100;

  let interpretation = '';
  if (positivePct > 50) interpretation = 'Majorite de mentions positives - bonne tendance';
  else if (negativePct > 50) interpretation = 'Majorite de mentions negatives - vigilance requise';
  else interpretation = 'Sentiment equilibre - a surveiller';

  return (
    <Box>
      <Box sx={{ display: 'flex', height: 28, borderRadius: 2, overflow: 'hidden', mb: 1.5 }}>
        <Tooltip title={`Positif: ${positive} mentions (${positivePct.toFixed(0)}%)`}>
          <Box sx={{ width: `${positivePct}%`, bgcolor: colors.positive, minWidth: positivePct > 0 ? 4 : 0, transition: 'width 0.8s cubic-bezier(0.4, 0, 0.2, 1)' }} />
        </Tooltip>
        <Tooltip title={`Neutre: ${neutral} mentions (${neutralPct.toFixed(0)}%)`}>
          <Box sx={{ width: `${neutralPct}%`, bgcolor: colors.neutral, minWidth: neutralPct > 0 ? 4 : 0, transition: 'width 0.8s cubic-bezier(0.4, 0, 0.2, 1)' }} />
        </Tooltip>
        <Tooltip title={`Negatif: ${negative} mentions (${negativePct.toFixed(0)}%)`}>
          <Box sx={{ width: `${negativePct}%`, bgcolor: colors.negative, minWidth: negativePct > 0 ? 4 : 0, transition: 'width 0.8s cubic-bezier(0.4, 0, 0.2, 1)' }} />
        </Tooltip>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, px: 0.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: colors.positive }} />
          <Typography variant="caption" sx={{ fontWeight: 600, color: colors.gray700 }}>
            {positivePct.toFixed(0)}%
          </Typography>
          <Typography variant="caption" sx={{ color: colors.gray400 }}>
            ({positive})
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: colors.neutral }} />
          <Typography variant="caption" sx={{ fontWeight: 600, color: colors.gray700 }}>
            {neutralPct.toFixed(0)}%
          </Typography>
          <Typography variant="caption" sx={{ color: colors.gray400 }}>
            ({neutral})
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: colors.negative }} />
          <Typography variant="caption" sx={{ fontWeight: 600, color: colors.gray700 }}>
            {negativePct.toFixed(0)}%
          </Typography>
          <Typography variant="caption" sx={{ color: colors.gray400 }}>
            ({negative})
          </Typography>
        </Box>
      </Box>
      <Typography variant="caption" sx={{ color: colors.gray600, fontStyle: 'italic' }}>
        {interpretation}
      </Typography>
    </Box>
  );
}

export default SentimentBar;
